import { gql } from '@apollo/client';

export const UPDATE_NOTIFICATION_PREFERENCES = gql`
  mutation updateNotificationPreferences($input: NotificationPreferencesInput!) {
    updateNotificationPreferences(input: $input) {
      content {
        newFlyer
        savedSearch
        upcomingSavedSearch
      }
    }
  }
`;
